import PropTypes from 'prop-types';
import clsx from 'clsx';
import classes from './ThumbnailFile.module.css';
import Icon from 'Components/Atoms/Icon/Icon';
import ThumbnailFileImage from './ThumbnailFileImage';
import ThumbnailFilePDF from './ThumbnailFilePDF';
import Spinner from 'Components/Atoms/Spinner';
import { isPDF } from 'Utils/files';

export default function ThumbnailFile({ url, loading = false, className, onMaximize }) {
    const Component = isPDF(url) ? ThumbnailFilePDF : ThumbnailFileImage;

    return (
        <button type="button" onClick={onMaximize} className={clsx(classes.thumbnail, className)}>
            <div className={classes.maximize}>
                <Icon name="maximize" size={16} color="rgba(32,32,32, .5)" />
            </div>

            {loading && <Spinner />}
            {!loading && <Component url={url} />}
        </button>
    );
}

ThumbnailFile.propTypes = {
    url: PropTypes.string,
    className: PropTypes.string,
    loading: PropTypes.bool,
    onMaximize: PropTypes.func,
};
